
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Innovacrystacabooking() {



    const cardData =
    {
        keyword: ' Innova Crysta Cab Booking',
        heading: 'Prince Cabs: Innova Crysta Cab Booking',
        headingDescription: 'Prince Cabs offers convenient Innova Crysta Cab Booking, perfect for luxury family travel, corporate tours, airport transfers, and outstation journeys. Our premium Innova Crysta vehicles are well-maintained, spacious, and equipped with modern amenities to ensure maximum comfort and safety. With professional chauffeurs, flexible schedules, and transparent pricing, we make your travel experience smooth and hassle-free. Choose Prince Cabs’ trusted Innova Crysta cab booking service for reliability, comfort, and affordable fares.',

        top: 'Top Places to Visit in Pune Outstation with Prince Cabs',

"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar, located 120 km from Pune, is one of Maharashtra’s most loved hill stations. Famous for its strawberry farms, boating at Venna Lake, and viewpoints like Arthur’s Seat and Wilson Point, it offers a refreshing escape from city life. The ancient Mahabaleshwar Temple adds spiritual significance. During monsoon, waterfalls and misty valleys make it magical. Winters bring a cozy holiday feel. It is among the top weekend getaways from Pune."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 65 km from Pune, Lonavala and Khandala are twin hill stations in the Sahyadris, ideal for quick trips. They are known for attractions like Tiger’s Leap, Bhushi Dam, Karla & Bhaja Caves, and Rajmachi Fort. Monsoon transforms the valleys into green carpets dotted with waterfalls. Adventure lovers enjoy trekking, camping, and Pawna Lake activities. Street food like hot vada pav and chikki adds local flavor. They remain Pune’s favorite weekend getaways."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, a planned hill city about 60 km from Pune, is inspired by Italian architecture and built around a serene lake. The Lakeside Promenade is lined with cafés, resorts, and vibrant streets. Boating, cycling, and adventure sports make it ideal for families and couples. The cityscape looks particularly scenic in monsoon. Wellness retreats here attract urban travelers. Lavasa blends modernity, leisure, and natural beauty."
  },
  {
    "title": "Panchgani",
    "description": "Located 100 km from Pune, Panchgani is a peaceful hill station surrounded by five hills. Table Land, Asia’s second-largest volcanic plateau, is its highlight. Strawberry farms, viewpoints, and boarding school heritage add charm. Paragliding and trekking attract adventure seekers. Its calm weather makes it a year-round destination. Panchgani is often visited along with Mahabaleshwar for a complete hill retreat."
  },
  {
    "title": "Matheran",
    "description": "Matheran, about 120 km from Pune, is Asia’s only automobile-free hill station. Known for its red-soil trails, toy train, and 30+ viewpoints like Panorama Point and Charlotte Lake, it is perfect for nature lovers. Trekkers enjoy its forested routes, especially in monsoon. The fresh air and eco-friendly vibe make it unique. Families and couples love its peaceful charm. It offers a vintage hill-station experience."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, around 140 km from Pune, is a coastal getaway famous for its beaches and sea forts. Popular spots include Alibaug Beach, Varsoli Beach, and Kolaba Fort. Adventure lovers enjoy water sports at Nagaon Beach. The town is also famous for fresh seafood and beach homestays. Sunset views over the Arabian Sea are spectacular. Alibaug is the perfect mix of history, leisure, and sea breeze."
  },
  {
    "title": "Tarkarli",
    "description": "Tarkarli, in Sindhudurg district, is about 385 km from Pune and worth the long drive for its pristine beaches. Known as Maharashtra’s scuba diving capital, it offers snorkeling, parasailing, and dolphin-spotting. The white sands and clear waters rival Goa’s charm. Homestays near the beach showcase Konkani hospitality. Sindhudurg Fort nearby adds historical value. It is a paradise for water sports and nature lovers."
  },
  {
    "title": "Shirdi",
    "description": "Located 185 km from Pune, Shirdi is one of India’s most important pilgrimage centers dedicated to Shri Sai Baba. Devotees visit the Samadhi Mandir, Dwarkamai, and Chavadi for blessings. The daily aartis attract lakhs of pilgrims. The town is well connected by road, making it a convenient outstation trip. Many combine Shirdi with Shani Shingnapur for a spiritual circuit. Shirdi is a soulful retreat for faith and devotion."
  },
  {
    "title": "Nashik",
    "description": "Nashik, 210 km from Pune, is a city of temples, vineyards, and riverside ghats. The Trimbakeshwar Temple, one of the 12 Jyotirlingas, is a major spiritual attraction. Panchavati, Sita Gufa, and Ramkund connect it to the Ramayana. Sula Vineyards and wineries make it India’s wine capital. Nashik also hosts the Kumbh Mela every 12 years, attracting millions. It is a balanced mix of spirituality and leisure."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur, about 230 km from Pune, is famous for the Mahalaxmi Temple, a Shakti Peetha of immense religious importance. Visitors also explore Rankala Lake, Panhala Fort, and Jyotiba Temple. Kolhapur is equally renowned for spicy Kolhapuri cuisine and traditional chappals. Its blend of devotion, culture, and shopping makes it a fulfilling trip. Festivals like Navratri and fairs attract large crowds. Kolhapur is a complete cultural experience."
  },
  {
    "title": "Satara (Kaas Plateau)",
    "description": "Satara, about 110 km from Pune, is famous for the Kaas Plateau, a UNESCO World Heritage Site. During monsoon, the plateau blooms with rare flowers, earning it the name ‘Valley of Flowers of Maharashtra.’ Sajjangad Fort and Thoseghar Waterfalls add to its charm. Trekkers and photographers love its natural beauty. The scenic landscapes are best enjoyed between August and October. Satara is a monsoon paradise for nature enthusiasts."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description": "Located near Aurangabad, around 250 km from Pune, the Ajanta and Ellora Caves are UNESCO World Heritage Sites. Ajanta features Buddhist frescoes and sculptures from the 2nd century BC, while Ellora showcases Hindu, Buddhist, and Jain rock-cut temples. The Kailasa Temple at Ellora is a monolithic masterpiece. These caves are a window into India’s ancient art and architecture. They are ideal for history buffs and cultural travelers."
  }
],


"services": [
    {
        "name": "Innova Car Rent per Day",
        "description": "Rent an Innova car in Pune on a per-day basis for local or outstation travel. Enjoy maximum flexibility, spacious seating, and reliable service with our clean and comfortable 7-seater cabs, perfect for full-day bookings with professional chauffeurs."
    },
    {
        "name": "Innova Crysta Cab Booking",
        "description": "Book Innova Crysta cabs in Pune for local city rides, airport transfers, or outstation trips. Our Crysta cab service offers plush seating, smooth rides, and experienced drivers to ensure a premium travel experience every time you ride."
    },
    {
        "name": "Book Innova Crysta for Outstation",
        "description": "Plan your outstation journey from Pune with our reliable Innova Crysta cab service. Perfect for long trips with family or colleagues, our vehicles come with ample legroom, luggage space, and trained drivers for a smooth and stress-free ride."
    },
    {
        "name": "Innova 8 Seater on Rent",
        "description": "Hire an 8-seater Innova for group travel, family tours, or special events. Spacious and ideal for long drives, our rental includes clean vehicles, courteous drivers, and budget-friendly packages suited for various travel needs."
    },
    {
        "name": "Innova Crysta Hire",
        "description": "Hire a Toyota Innova Crysta in Pune for luxury and comfort during your travels. Whether it’s for corporate travel, sightseeing, or family holidays, our Crysta hire service ensures a high-end travel experience with top-rated safety features."
    },
    {
        "name": "Innova Crysta Taxi Booking",
        "description": "Easily book Innova Crysta taxis in Pune for airport pickups, city tours, or weekend getaways. Our modern booking system offers instant confirmation, multiple fare options, and timely service from skilled and professional drivers."
    },
    {
        "name": "Innova Crysta Airport Drop",
        "description": "Get timely and hassle-free airport drop services with Innova Crysta in Pune. Enjoy premium comfort, ample luggage space, and on-time pickups for stress-free transfers to Pune Airport or nearby destinations."
    },
    {
        "name": "Innova Car for Rent",
        "description": "Rent a Toyota Innova in Pune for city use, weddings, business travel, or outstation trips. Choose from flexible hourly, daily, or per km packages, and travel comfortably with our verified drivers and well-maintained vehicles."
    },
    {
        "name": "Innova Crysta Taxi",
        "description": "Travel in luxury with our Innova Crysta taxi service in Pune. Whether you're commuting locally or going outstation, our Crysta taxis are known for reliability, comfort, and top-class customer service for all travel purposes."
    },
    {
        "name": "Innova Crysta per km Rate",
        "description": "Check the most affordable and transparent per km rates for Innova Crysta rentals in Pune. Ideal for long-distance travel, our per km pricing includes fuel, driver, and tolls, offering excellent value for premium travel needs."
    },
    {
        "name": "Innova Crysta for Rent Near Me",
        "description": "Find Innova Crysta rentals near your location in Pune for convenient and fast bookings. Our fleet of Crysta vehicles is available across the city for local and outstation use, with professional drivers and reliable service."
    },
    {
        "name": "Innova Crysta on Rent",
        "description": "Get an Innova Crysta on rent in Pune for short or long trips. Whether it’s a business tour, weekend getaway, or family function, our Crysta rentals offer luxurious interiors, safety, and flexible rental options to suit your needs."
    },
    {
        "name": "Innova Crysta Round Trip Booking",
        "description": "Book a round trip with Innova Crysta from Pune for outstation destinations. Our round-trip packages include experienced drivers, comfortable seating, and competitive rates for a complete and worry-free travel experience."
    },
    {
        "name": "Luxury Innova Crysta Rental",
        "description": "Experience top-tier comfort with our luxury Innova Crysta rental in Pune. Equipped with premium interiors and driven by courteous chauffeurs, this service is perfect for VIP travel, executive movement, and special events."
    },
    {
        "name": "Affordable Innova Crysta Cab",
        "description": "Choose our budget-friendly Innova Crysta cab service in Pune for high-quality travel at reasonable rates. Ideal for family trips, outstation tours, and corporate rides, we ensure affordability without compromising comfort or safety."
    }
],
"tableData": [
    ["Innova Car Rent per Day", "Innova Crysta Cab Booking"],
    ["Book Innova Crysta for Outstation", "Innova 8 Seater on Rent"],
    ["Innova Crysta Hire", "Innova Crysta Taxi Booking"],
    ["Innova Crysta Airport Drop", "Innova Car for Rent"],
    ["Innova Crysta Taxi", "Innova Crysta per km Rate"],
    ["Innova Crysta for Rent Near Me", "Innova Crysta on Rent"],
    ["Innova Crysta Round Trip Booking", "Luxury Innova Crysta Rental"],
    ["Affordable Innova Crysta Cab", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Crysta Cab Booking for Comfortable Travel",
        "WhyChoosedescription": "Prince Cabs offers premium Toyota Innova Crysta cab bookings, perfect for travelers seeking spacious, luxurious, and comfortable rides. Whether for airport transfers, corporate travel, family outings, or outstation journeys, the Innova Crysta ensures a smooth and elegant experience with plush interiors, advanced features, and ample legroom."
    },
    {
        "WhyChooseheading": "Modern & Well-Maintained Innova Crysta Fleet",
        "WhyChoosedescription": "Our Innova Crysta vehicles are regularly serviced and meticulously maintained to guarantee top performance and cleanliness. Each cab features modern amenities like touchscreen infotainment, climate control, and comfortable seating arrangements designed to enhance your travel experience across Pune and beyond."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Safe and Courteous Service",
        "WhyChoosedescription": "We deploy professional drivers trained to handle both city traffic and long-distance drives. Familiar with Pune’s roads and outstation routes, they ensure punctual pickups, safe driving, and respectful service, allowing you to relax and enjoy your journey worry-free."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Needs",
        "WhyChoosedescription": "Whether you require a one-way trip, round trip, or hourly rental of the Innova Crysta, Prince Cabs provides flexible booking options. Book easily via phone, WhatsApp, or online portal, with instant confirmations and customizable packages that fit your travel schedule."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our pricing for Innova Crysta cab bookings is clear and competitive. We offer per kilometer rates as well as fixed packages for popular routes, all inclusive of driver allowance, tolls, and taxes. You receive an upfront fare estimate with no surprises at the end of your trip."
    },
    {
        "WhyChooseheading": "Stringent Hygiene & Safety Protocols",
        "WhyChoosedescription": "Your safety is paramount. All Innova Crysta cabs are sanitized before and after every ride. Vehicles are equipped with essential safety features, and our drivers follow strict hygiene guidelines to provide a clean and safe travel environment."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
        "WhyChoosedescription": "Our dedicated customer care team is available 24/7 to assist you with Innova Crysta bookings, route planning, and any travel-related queries. We ensure your booking process is smooth and your journey is comfortable from start to finish."
    }
]

























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Innova Crysta cab booking in Pune?',
        answer: 'Yes, Prince Cabs provides premium Innova Crysta cabs for local, airport, and outstation travel from Pune. Ideal for family trips, business travel, and group outings.',
    },
    {
        question: 'What are the key features of the Innova Crysta cab?',
        answer: 'Our Innova Crysta cabs come with captain seats, rear AC vents, ample luggage space, plush interiors, and enhanced legroom for maximum comfort.',
    },
    {
        question: 'How much does it cost to book an Innova Crysta cab?',
        answer: 'Innova Crysta cabs are available at ₹20–₹21 per km for outstation travel. Local and airport rates may vary based on hours and distance.',
    },
    {
        question: 'Is Innova Crysta suitable for outstation travel?',
        answer: 'Absolutely! Innova Crysta is the top choice for long-distance travel due to its comfort, power, and spacious seating. Perfect for hilly terrain and highways.',
    },
    {
        question: 'Can I book an Innova Crysta for airport transfer in Pune?',
        answer: 'Yes, Prince Cabs offers reliable airport pickup and drop services in Innova Crysta for a relaxed and premium travel experience.',
    },
    {
        question: 'Are Innova Crysta cabs sanitized and well-maintained?',
        answer: 'Yes, all our Innova Crysta vehicles are regularly sanitized, cleaned, and serviced. Our drivers are background-verified and trained for customer satisfaction.',
    },
    {
        question: 'How can I book an Innova Crysta cab with Prince Cabs?',
        answer: 'Booking is simple—just call our helpline or visit our website. Share your trip details and we’ll confirm your Innova Crysta cab instantly.',
    },
];

const testimonials = [
    {
        name: "Mr. Ajit Nimbalkar",
        position: "Business Executive",
        text: "Prince Cabs delivered an excellent Innova Crysta for my Pune to Mumbai business trip. Extremely comfortable and professional service. Worth every rupee!",
        image: "/img/testimonial/testimonial-thumb-innova-crysta-1.png",
    },
    {
        name: "Mrs. Aarti Kulkarni",
        position: "Weekend Traveler",
        text: "We booked an Innova Crysta for a family weekend getaway. Clean car, on-time service, and super spacious. Will definitely book again from Prince Cabs.",
        image: "/img/testimonial/testimonial-thumb-innova-crysta-2.png",
    },
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta Cab Booking",
  "image": "https://princecab.com/assets/images/innova-crysta-cab.jpg",
  "description": "Book Innova Crysta cabs with Prince Cabs for comfortable and spacious travel. Ideal for outstation trips, airport drops, and round trips with affordable pricing and luxury service.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "0",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/innova-crysta-cab-booking"
  }
};






    return (
        <div>
<Helmet>
  <title>Innova Crysta Cab Booking | Luxury & Affordable Innova Rental | Prince Cabs</title>
  <meta
    name="description"
    content="Book Innova Crysta cab with Prince Cabs for outstation trips, airport transfers, and round trips. Enjoy luxury, spacious travel with affordable Innova Crysta rental rates."
  />
  <meta
    name="keywords"
    content="Innova Car Rent per Day, Innova Crysta Cab Booking, Book Innova Crysta for Outstation, Innova 8 Seater on Rent, Innova Crysta Hire, Innova Crysta Taxi Booking, Innova Crysta Airport Drop, Innova Car for Rent, Innova Crysta Taxi, Innova Crysta per km Rate, Innova Crysta for Rent Near Me, Innova Crysta on Rent, Innova Crysta Round Trip Booking, Luxury Innova Crysta Rental, Affordable Innova Crysta Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovacrystacabooking;